/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { DeliveryMethodEnumType } from "./DeliveryMethodEnum"
import { RootStoreType } from "./index"


/**
 * CustomerNotificationsSummaryDtoBase
 * auto generated base class for the model CustomerNotificationsSummaryDtoModel.
 */
export const CustomerNotificationsSummaryDtoModelBase = ModelBase
  .named('CustomerNotificationsSummaryDto')
  .props({
    __typename: types.optional(types.literal("CustomerNotificationsSummaryDto"), "CustomerNotificationsSummaryDto"),
    deliveryMethod: types.union(types.undefined, types.null, DeliveryMethodEnumType),
    reachableCustomers: types.union(types.undefined, types.null, types.number),
    unreachableCustomers: types.union(types.undefined, types.null, types.number),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class CustomerNotificationsSummaryDtoModelSelector extends QueryBuilder {
  get deliveryMethod() { return this.__attr(`deliveryMethod`) }
  get reachableCustomers() { return this.__attr(`reachableCustomers`) }
  get unreachableCustomers() { return this.__attr(`unreachableCustomers`) }
}
export function selectFromCustomerNotificationsSummaryDto() {
  return new CustomerNotificationsSummaryDtoModelSelector()
}

export const customerNotificationsSummaryDtoModelPrimitives = selectFromCustomerNotificationsSummaryDto().deliveryMethod.reachableCustomers.unreachableCustomers
